export const MAX_PLAN_DESCRIPTION_LENGTH = 50;

export function validatePlanDescription(description: string) {
  if (description.length > MAX_PLAN_DESCRIPTION_LENGTH) {
    return `Description must contain fewer than ${MAX_PLAN_DESCRIPTION_LENGTH} characters.`;
  }
  return '';
}
